const ROOT_REGISTRY_KEY = '__mibodega_pos_react_root_registry__';

type RootRegistry = WeakMap<object, object>;

function getRootRegistry(): RootRegistry {
  const scope = globalThis as typeof globalThis & {
    [ROOT_REGISTRY_KEY]?: RootRegistry;
  };

  return (scope[ROOT_REGISTRY_KEY] ??= new WeakMap<object, object>());
}

/** Reuses the React root when Vite re-evaluates the entrypoint during HMR. */
export function getOrCreateRoot<Container extends object, Root extends object>(
  container: Container,
  createRoot: (container: Container) => Root,
): Root {
  const registry = getRootRegistry();
  const existing = registry.get(container);
  if (registry.has(container)) {
    return existing as Root;
  }

  const root = createRoot(container);
  registry.set(container, root);
  return root;
}
